export default "__VITE_ASSET__cce4aa6d__"